/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get, isEmpty } from 'lodash';

// Components
import Badge from 'shared/ui/components/Badge.vue';

const __vue_script__ = {
    name: 'DocumentInfo',

    components: { Badge },

    props: {
        document: {
            type: Object,
            required: true
        },

        event: {
            type: Object,
            required: true
        },

        timestamp: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            eventId: this.event._id || this.event.id,
            author: null,
            description: null,
            created: null,
            owner: null,
            status: null,
            tool: null,
            metadata: null
        };
    },

    computed: {
        userTs() {
            if (!this.timestamp) return '-';
            return this.$utils.time.tsToFormat(this.timestamp, 'llll');
        },

        eventTs() {
            if (!this.timestamp) return '-';
            return this.$utils.time.tsToFormat(this.timestamp, 'llll', this.event.timezone);
        },

        showInfo() {
            return this.showTimestamp || this.showDetails || this.owner;
        },

        showTimestamp() {
            return this.timestamp > 0;
        },

        showDetails() {
            return this.type ||
                this.status ||
                this.created ||
                this.lastChange ||
                this.author ||
                this.tool ||
                this.document.created_by;
        },

        lastChange() {
            return get(this.document, 'fp_last_changes.timestamp');
        },

        lastChangeAuthor() {
            return get(this.document, 'fp_last_changes.author');
        },

        lastChangeSource() {
            return get(this.document, 'fp_last_changes.source') || '';
        },

        isPaxOwned() {
            return this.document.fp_owner && !['private', 'global'].includes(this.document.fp_owner);
        },

        type() {
            return this.document.fp_type || this.document.type;
        },

        hasActions() {
            return ['fp_ext_id', 'fp_fstg_page'].includes(Object.keys(this.document)) || ['person', 'message', 'background_job'].includes(this.document.fp_type);
        }
    },

    watch: {
        document: {
            immediate: true,
            async handler() {
                const doc = this.document;
                const source = this.lastChangeSource;
                const [author, tool] = source.split('via');
                this.author = (this.lastChangeAuthor || author || '').replace('org.couchdb.user:', '');
                this.tool = this.lastChangeAuthor ? author : tool;

                this.created = doc.created || doc.fp_created_timestamp;

                this.owner = this.formatOwner();
                this.status = doc.fp_status;

                if (doc.fp_type) {
                    const metadata = await this.$services.metadata.getMetadataForType(this.eventId, doc.fp_type);

                    if (metadata._description) {
                        this.description = this.$utils.dom.compile(metadata._description, doc);
                    }

                    if (!isEmpty(metadata)) {
                        this.metadata = metadata;
                    }
                }
            }
        }
    },

    methods: {
        formatTime(ts) {
            return this.$utils.time.tsToFormat(ts, 'llll');
        },

        getStatusClass() {
            switch (this.status) {
                case 'active':
                    return 'success';
                case 'cancelled':
                    return 'danger';
                case 'inactive':
                case 'hidden':
                    return 'warn';
                default:
                    return 'info';
            }
        },

        formatOwner() {
            let owner = (this.document.fp_owner || '').replace('org.couchdb.user:', '');

            if (this.isPaxOwned) {
                owner = this.$utils.strings.shrink(owner);
            }

            return owner;
        },

        openOwner() {
            if (this.isPaxOwned) {
                this.$emit('select', this.document.fp_owner);
            }
        },

        async copyExtId() {
            await navigator.clipboard.writeText(this.document.fp_ext_id);

            this.$notify({
                group: 'flashes',
                text: this.$i18n.t('general.copy_success').toString(),
                type: 'success'
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showInfo)?_c('div',{staticClass:"document-info"},[(_vm.owner)?_c('div',{staticClass:"owner"},[(_vm.owner.startsWith('global') || _vm.owner === 'private')?_c('badge',{class:{ 'danger': !_vm.owner.startsWith('global'), 'success': _vm.owner.startsWith('global')}},[_c('i',{class:{ 'ic-globe': _vm.owner.startsWith('global'), 'ic-shield': _vm.owner === 'private'}}),_vm._v(_vm._s(_vm.owner))]):_c('badge',{class:{ 'danger': _vm.owner !== 'global', 'success': _vm.owner === 'global'},attrs:{"config":{ action: _vm.openOwner }}},[_c('i',{staticClass:"ic-lock"}),_vm._v(_vm._s(_vm.owner))])],1):_vm._e(),_c('h4',[_vm._v(_vm._s(_vm.$t('dev_tools.document_editor.info')))]),(_vm.timestamp > 0)?_c('div',{staticClass:"alert alert-warning timestamp"},[_c('h4',[_vm._v(_vm._s(_vm.$t('dev_tools.document_editor.timestamp')))]),_c('strong',[_vm._v("Event:")]),_c('span',[_vm._v(" "+_vm._s(_vm.eventTs))]),_c('strong',[_vm._v("Local:")]),_c('span',[_vm._v(" "+_vm._s(_vm.userTs))])]):_vm._e(),(_vm.showDetails)?_c('div',{staticClass:"alert alert-notice"},[(_vm.type)?[_c('strong',[_vm._v("Type:")]),_c('i',{class:_vm.$utils.assets.getIconForType(_vm.type)}),(_vm.document.fp_type && _vm.metadata)?_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.$emit('select', 'metadata', _vm.type)}}},[_c('code',{staticClass:"line"},[_vm._v(_vm._s(_vm.type))])]):_c('code',{staticClass:"line"},[_vm._v(_vm._s(_vm.type))]),(_vm.description)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.description),expression:"description"}]},[(_vm.metadata._type_representation)?_c('i',{staticClass:"ic-arrow-right"}):_vm._e(),_vm._v(_vm._s(_vm.metadata._type_representation)),_c('i',{staticClass:"ic-info-fill"})]):_c('span')]:_vm._e(),(_vm.status)?[_c('strong',[_vm._v("Status:")]),_c('span',[_c('badge',{class:_vm.getStatusClass()},[_vm._v(_vm._s(_vm.status))])],1)]:_vm._e(),(_vm.created)?[_c('strong',[_vm._v("Created at:")]),_c('span',[_vm._v(" "+_vm._s(_vm.formatTime(_vm.created)))])]:_vm._e(),(_vm.document.created_by)?[_c('strong',[_vm._v("Created by:")]),_c('code',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.document.created_by),expression:"document.created_by"}]},[_vm._v(" "+_vm._s(_vm.document.created_by))])]:_vm._e(),(_vm.lastChange)?[_c('strong',[_vm._v("Changed at:")]),_c('span',[_vm._v(" "+_vm._s(_vm.formatTime(_vm.lastChange)))])]:_vm._e(),(_vm.author)?[_c('strong',[_vm._v("Changed by:")]),_c('code',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.author),expression:"author"}]},[_vm._v(" "+_vm._s(_vm.author))])]:_vm._e(),(_vm.tool)?[_c('strong',[_vm._v("Tool used:")]),_c('span',[_vm._v(" "+_vm._s(_vm.tool))])]:_vm._e(),(_vm.hasActions)?_c('div',{staticClass:"actions"},[(_vm.document.fp_type === 'person')?_c('button',{staticClass:"btn btn-mini btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('select', ((_vm.document._id) + "-act"))}}},[_vm._v("Activations")]):_vm._e(),(_vm.document.fp_type === 'person')?_c('button',{staticClass:"btn btn-mini btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('select', ((_vm.document._id) + "-photo"))}}},[_vm._v("Picture")]):_vm._e(),(_vm.document.fp_type === 'message' && _vm.document.job_id)?_c('button',{staticClass:"btn btn-mini btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('select', _vm.document.job_id)}}},[_vm._v("Scheduled job")]):_vm._e(),(_vm.document.fp_type === 'background_job')?_c('button',{staticClass:"btn btn-mini btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('select', ((_vm.document._id) + "-job"))}}},[_vm._v("Job")]):_vm._e(),(_vm.document.fp_fstg_page)?_c('button',{staticClass:"btn btn-mini btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('select', ("fstg-page-" + (_vm.document.fp_fstg_page)))}}},[_vm._v("FSTG page")]):_vm._e(),(_vm.document.fp_ext_id)?_c('button',{staticClass:"btn btn-mini btn-success",attrs:{"type":"button"},on:{"click":_vm.copyExtId}},[_vm._v("Copy Ext ID")]):_vm._e()]):_vm._e()],2):_vm._e()]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "DocumentInfo.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__